import axios from "axios";
import {
  DECCAN_REDIRECT_URLS,
  DOMAIN_CAPTURING_GROUP_REGEX,
  NORMALIZE_URL_REGEX,
  PRAJAVANI_REDIRECT_URLS,
  __INTERNAL_APP_NAME__DECCAN,
  __INTERNAL_APP_NAME__PRAJAVANI,
} from "./contant";
import Cookies from "js-cookie";


export const apiHandler = async ({
  method = "PUT",
  url,
  authorization,
  reqBody,
}) => {
  const options = {
    method,
    url,
    headers: {
      "Content-Type": "application/json",
      Authorization: authorization,
    },
    data: reqBody,
  };
  try {
    const response = await axios(options);
    return response;
  } catch (error) {
    return error;
  } finally {
  }
};

export const getAppFlag = ({ appUrl }) => {
  const callbackUrl = localStorage.getItem("callbackUrl") || "";
  return callbackUrl?.toLowerCase()?.includes(appUrl);
};

// This function normalizes a given URL by removing the protocol and optional 'www.' prefix.
export function normalizeUrl(inputUrl) {
  if (!inputUrl) inputUrl = "";

  // Remove query parameters from the URL
  const urlWithoutParams = inputUrl.split("?")[0];

  let domain = urlWithoutParams.replace(NORMALIZE_URL_REGEX, "");

  // Extract domain using a capturing group
  const match = domain.match(DOMAIN_CAPTURING_GROUP_REGEX);

  if (match) {
    return match[0]; // Extracted domain
  } else {
    return ""; // Invalid URL format
  }
}

const mapperRedirectUrlToRedirectAppInternalName = new Map();

// Function to populate the map with URL mappings
function populateUrlToValueMap(urls, appName) {
  urls.forEach((url) => {
    mapperRedirectUrlToRedirectAppInternalName.set(normalizeUrl(url), appName);
  });
}

// Populate the map
populateUrlToValueMap(PRAJAVANI_REDIRECT_URLS, __INTERNAL_APP_NAME__PRAJAVANI);
populateUrlToValueMap(DECCAN_REDIRECT_URLS, __INTERNAL_APP_NAME__DECCAN);

export { mapperRedirectUrlToRedirectAppInternalName };

export const fetchUserData = async () => {
  try {
    const checkIsEmailPresentResponse = await axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_BASE_URL}/auth/me`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("st-access-token")}`,
        rid: "thirdpartypasswordless",
      },
    });
    if (checkIsEmailPresentResponse.status === 200) {
      // return checkIsEmailPresentResponse?.data?.userData?.emails?.length > 0;
      return checkIsEmailPresentResponse?.data
    }
  } catch (error) {
    return error;
  }
};

export function removeCountryCode(phoneNumber) {
  if (!phoneNumber) {
    // Return the original phoneNumber if it's falsy
    return phoneNumber;
  }
  // Replace '+91' with an empty string only if phoneNumber has a value
  return phoneNumber.replace(/^\+91/, '');
}
